<app-menu></app-menu>
<app-carousel-sect></app-carousel-sect>
<div class="p-md-2 p-sm-1"></div>
<app-shop-section></app-shop-section>
<app-popular-slider></app-popular-slider>
<app-popular-product-grid [title]="'Popular Products'" [data]="arr4" ></app-popular-product-grid>
<app-popular-product-grid [title]="'Products on Sale'" [data]="arr5" ></app-popular-product-grid>
<app-mail-liast></app-mail-liast>
<app-footer></app-footer>
<app-banner></app-banner>
<div class="d-flex justify-content-center" >
  <button class="cardBtns d-sm-block d-md-none">
    View All Products
  </button>
</div>
<div class=" col-md-12 p-3 d-sm-block d-md-none">

</div>
